<template>
  <div>
    <div class="box mb20">
      <el-page-header
        @back="$router.go(-1)"
      ></el-page-header>
    </div>
    <el-card class="mb15" shadow="hover">
      <el-row>
        <el-input
          :placeholder="$t('search')"
          clearable
          v-model="filter.search"
          @keyup.enter.native="get_list"
        ></el-input>
      </el-row>
      <el-row class="mt20 flexBC" type="flex" align="middle">
        <div>
          <el-button @click="get_list" type="primary" class="search">{{
            $t("search_zh")
          }}</el-button>
          <el-button @click="reset" type="info">{{
            $t("btnTip.reset")
          }}</el-button>
        </div>
        <div>
          <el-button @click="toPage('toNotice')" type="success">{{
            $t("readList.toNotice")
          }}</el-button>
          <el-button @click="toPage('toTopic')" type="success">{{
            $t("readList.toTopic")
          }}</el-button>
          <el-button @click="toPage('toComment')" type="success">{{
            $t("readList.toComment")
          }}</el-button>
        </div>
      </el-row>
    </el-card>
    <el-card shadow="hover">
      <div class="flexBC mb20">
        <el-button type="primary" @click="handleClick('add')">{{
          $t("btnTip.add")
        }}</el-button>
        <div>
          <el-button type="primary" @click="outExe">{{ $t("outExe") }}</el-button>
          <el-button
            type="primary"
            @click="outExeAll('readTask',attendanceList)"
            >전체출력</el-button>
          </div>
      </div>
      <my-table
        :columns="columns"
        :data="list_data.list"
        :showIndex="false"
        :showSelection="false"
        :cellStyle="{ padding: '6px 0' }"
        :headerCellStyle="{
          background: 'rgba(51, 55, 68, 1)',
          color: '#fff',
        }"
        @emitSelection="allSelect"
        @sortChange="sort_change"
      >
        <template v-slot:content="slotProps">
          <div class="mutiple" v-html="slotProps.callback.row.content"></div>
        </template>
       <template v-slot:type="slotProps">
          <div>{{type(slotProps.callback.row.type)}}</div>
        </template>
        <template v-slot:active="slotProps">
          <el-tag :type="activeTag(slotProps.callback.row.active)">{{active(slotProps.callback.row.active)}}</el-tag>
        </template>
        <template v-slot:operation="slotProps">
            <el-button
              @click="handleClick('toAttendanceList',slotProps.callback.row)"
              type="warning"
              size="mini"
            >{{$t('readTaskList.toAttendanceList')}}</el-button>
           <el-tooltip class="item" effect="dark" :content="$t('btnTip').edit" placement="top">
            <el-button
              @click="handleClick('edit',slotProps.callback.row)"
              icon="el-icon-edit-outline"
              type="primary"
              size="mini"
            ></el-button>
          </el-tooltip>
          <el-tooltip
            class="item"
            effect="dark"
            :content="$t('btnTip').delete"
            placement="top"
          >
            <el-button
              size="mini"
              type="danger"
              @click="del(slotProps.callback.row.id)"
              >{{ $t("btnTip").delete }}</el-button
            >
          </el-tooltip>
        </template>
      </my-table>
      <page
        :total="list_data.total"
        :page_size.sync="pageSize"
        :page.sync="page"
      />
    </el-card>
  </div>
</template>
<script>
import time from '@/utils/timeFormat'
import { mixin_list } from "@/mixins";
import page from "@/components/page";
import myTable from "@/components/table";
import { readTaskList, deleteReadTask, attendanceList } from "@/api/api";
export default {
  name: "readTaskList",
  mixins: [mixin_list(readTaskList)],
  components: {
    myTable,
    page,
  },
  data() {
    return {
      filter: {
        search: "",
        club:this.$route.params.readId
      },
      columns: [
        {
          label: "ID",
          sortable: true,
          prop: "id",
          width: 80,
        },
         {
          label: this.$t("readTaskList.create_time"),
          sortable: true,
          prop: "create_time",
        },
        {
          label: this.$t("readTaskList.publisher_name"),
          sortable: true,
          prop: "publisher_name",
        },
        {
          label: this.$t("readTaskList.title"),
          sortable: true,
          prop: "title"
        },
        {
          label: this.$t("readTaskList.content"),
          sortable: true,
          prop: "content",
          slot:"content"
        },
        {
          label: this.$t("readTaskList.end_time"),
          sortable: true,
          prop: "end_time"
        },
        {
          label: this.$t("readTaskList.order"),
          sortable: true,
          prop: "order"
        },
        {
          label: this.$t("readTaskList.type"),
          sortable: true,
          prop: "type",
          slot:"type"
        },
        {
          label: this.$t("readTaskList.active"),
          sortable: true,
          prop: "active",
          slot:"active"
        },
        {
          label: this.$t("operation"),
          prop: "",
          width: 300,
          slot: "operation",
        },
      ]
    }
  },
  methods: {
    attendanceList,
    toPage(toPage){
      switch(toPage){
        case 'toTask':
          this.$router.replace(`/readManagement/readList/${this.$route.params.readId}/readTaskList`)
          return
        case 'toTopic':
          this.$router.replace(`/readManagement/readList/${this.$route.params.readId}/readTopicList`)
          return
        case 'toNotice':
          this.$router.replace(`/readManagement/readList/${this.$route.params.readId}/readNoticeList`)
          return
        case 'toComment':
          this.$router.replace(`/readManagement/readList/${this.$route.params.readId}/readCommentList`)
          return
      }
    },
    type(type){
        switch(type){
            case '0':
                return this.$t('readTaskList.type0')
            case '1':
                return this.$t('readTaskList.type1')
        }
    },
    active(active){
        switch(active){
            case 0:
                return this.$t('readTaskList.active0')
            case 1:
                return this.$t('readTaskList.active1')
        }
    },
    activeTag(activeTag){
        switch(activeTag){
            case 0:
                return 'info'
            case 1:
                return 'success'
        }
    },
    async handleClick(type, data) {
      switch (type) {
        case "add":
          this.$router.push(`/readManagement/readList/${this.$route.params.readId}/readTaskList/edit`)
          break;
        case "edit":
          this.$router.push(`/readManagement/readList/${this.$route.params.readId}/readTaskList/edit?id=${data.id}`)
          break;
        case "toAttendanceList":
             this.$router.push(`/readManagement/readList/${this.$route.params.readId}/readTaskList/${data.id}/attendanceList`)
          break;
      }
    },
    async del(id) {
      this.$confirm(this.$t('readTaskList').sureDeleteTask, this.$t('tips'), {
        confirmButtonText: this.$t('btnTips').submit,
        cancelButtonText: this.$t('btnTips').cancel,
        type: 'warning'
      }).then(async () => {
        let res = await deleteReadTask(id)
        this.get_list()
      }).catch({
      })
    },
  },
};
</script>
<style lang="scss" scoped>

</style>